import { DeviceModels } from './types';

export const gatewayMapper = [
  {
    gatewayModel: [DeviceModels.ISGI],
    bluetoothModels: [DeviceModels.W550, DeviceModels.BM96],
  },
  {
    gatewayModel: [DeviceModels.GW9017],
    bluetoothModels: [
      DeviceModels.IR42,
      DeviceModels.PO200,
      DeviceModels.P30,
      DeviceModels.W550,
      DeviceModels.FORA6,
      DeviceModels.IR20,
      DeviceModels.P80,
    ],
  },
];

export const allBluetoothDevices = gatewayMapper.reduce(
  (result, gw) => [...result, ...gw.bluetoothModels],
  [] as DeviceModels[]
);

export const allGatewayDevices = gatewayMapper.reduce(
  (result, gw) => [...result, ...gw.gatewayModel],
  [] as DeviceModels[]
);
